<!-- vertical layout -->
<app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>

<!-- horizontal layout --> 
<app-horizontal *ngIf="isHorizontalLayoutRequested()"></app-horizontal>